import { DataBean } from "../DataBean";

export class TypeNovelty extends DataBean {

  public async getTypeNoveltyCatalogPorPropiedades(properties: any, maxRows: number): Promise<any> {
    return this.getCustomService(
      "TalentERP",
      "java.util.List_getTypeNoveltyCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteTypeNovelty(idtypenovelty: number): Promise<any> {
    return this.getCustomService(
      "TalentERP",
      "boolean_deleteTypeNovelty_Number",
      [idtypenovelty]
    );
  }

  public async updateTypeNovelty(bean: any): Promise<any> {
    return this.getCustomService(
      "TalentERP",
      "com.orange.people.talent.bean.TypeNovelty_updateTypeNovelty_com.orange.people.talent.bean.TypeNovelty",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.people.talent.bean.TypeNovelty",
        },
      ]
    );
  }
}
